import { AfterViewInit, Component, Input } from '@angular/core';
import { UserService } from '@core/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OverviewAdminResourceModel } from '@shared/overview/overview-admin-resources/overview-admin-resource.model';
import { BrandedWistiaComponent } from '@shared/wistia/branded-wistia/branded-wistia.component';

@Component({
  selector: 'zbp-overview-admin-resources',
  templateUrl: './overview-admin-resources.component.html',
  styleUrls: ['./overview-admin-resources.component.scss'],
  standalone: false
})
export class OverviewAdminResourcesComponent implements AfterViewInit {

  autoPlayOnFirstVisitResource?: OverviewAdminResourceModel;
  _resources: Array<OverviewAdminResourceModel> = [];

  @Input() set resources(resources: Array<OverviewAdminResourceModel>) {
    // Only displays resources as links when they have a thumbnail.
    this._resources = resources.filter(item => item.thumbnailSrc);
    this.autoPlayOnFirstVisitResource = resources.find(
      (item: OverviewAdminResourceModel) => item?.autoPlayOnFirstVisit && item.wistiaCode
    );
  }

  constructor(
    private ngbModal: NgbModal,
    private userService: UserService,
  ) {
  }

  ngAfterViewInit() {
    if (this.userService.firstLogin) {
      this.playVideo(null, this.autoPlayOnFirstVisitResource?.wistiaCode);
      this.userService.firstLogin = false;
    }
  }

  playVideo(event: Event, wistiaCode: string): boolean {
    if (wistiaCode) {
      event?.preventDefault();
      const modalRef = this.ngbModal.open(BrandedWistiaComponent, {
        size: 'lg',
        modalDialogClass: 'transparent-bg',
      });
      modalRef.componentInstance.isModal = true;
      modalRef.componentInstance.wistiaCode = wistiaCode;
    }
    return false;
  }

}
